import API from "utils/API";
import moment from "moment";
import { useState } from "react";
import Address from "typedef/Address";
import { useForm } from "react-hook-form";
import { RegisterResponseType } from "typedef/RegisterForm";
import { useLocation, useSearchParams } from "react-router-dom";

export type RegisterFormCoborrowerInputs = {
  email: string;
  agree: boolean;
  certify: boolean;
  password: string;
  lastName: string;
  firstName: string;
  phoneNumber: string;
  employmentType: string;
  primaryBorrower: string;
  propertyAddress: string;
  address?: Address | null;
  socialSecurityNumber: string;
  dateOfBirth: string | undefined;
};

export type RegisterFormCoborrowerDialogs =
  | "terms"
  | "privacy"
  | "verify"
  | "error"
  | "communications";

const useRegisterFormCoborrower = (
  email?: string,
  name?: string,
  borrowerFullName?: string
) => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const [errorMessage, setErrorMessage] = useState<string>();
  const [openedDialog, setOpenedDialog] =
    useState<RegisterFormCoborrowerDialogs>();
  const form = useForm<RegisterFormCoborrowerInputs>({
    defaultValues: {
      address: location.state as Address,
      firstName: name ?? "",
      employmentType: "",
      primaryBorrower: borrowerFullName,
    },
  });

  const onSubmit = form.handleSubmit(async (data) => {
    const { street_line, ...address } = data.address as Address;
    const street = street_line;
    const response = await API.post<RegisterResponseType>({
      url: `/coborrower-register`,
      data: {
        address: {
          street,
          ...address,
        },
        hasAcceptTerms: true,
        agreeNotifications: true,
        email: email?.trim(),
        password: data.password,
        lastName: data.lastName,
        firstName: data.firstName,
        employmentType: data.employmentType,
        phoneNumber: data.phoneNumber.replace(/ /g, ""),
        socialSecurityNumber: data.socialSecurityNumber.replace(/-/g, ""),
        dateOfBirth: moment(data.dateOfBirth).format("yyyy/MM/DD"),
        code: searchParams.get("code"),
      },
    });
    if ("error" in response) {
      setErrorMessage(response.error);
      setOpenedDialog("error");
    } else {
      setOpenedDialog("verify");
    }
  });

  return {
    onSubmit,
    openedDialog,
    errorMessage,
    setOpenedDialog,
    setErrorMessage,
    ...form,
  };
};

export default useRegisterFormCoborrower;
